import { IKeyValueSynchronous } from 'core-ts-types';
import { Datasource } from 'utility-ts-datasource';

import { StudentMenu } from '../builders/student_menu_builder';

export type TStudentMenuDatasource = IKeyValueSynchronous<StudentMenu>;

angular.module('lib').factory('ngStudentMenuDatasource', (): TStudentMenuDatasource => {
  return new Datasource<StudentMenu>({
    builderType: StudentMenu,
    autoId: false
  });
});



// WEBPACK FOOTER //
// ./app/lib/responsive_navigation/datasource/student_menu_datasource.ts